import { StateService, UIRouterGlobals } from "@uirouter/angular";
import { Component, Input } from "@angular/core";
import { BroadcastService } from "@webapp/core/broadcast/services/broadcast.service";
import { SubNavOption } from "@webapp/navigation/models/sub-nav-options.models";

@Component({
  selector: "sub-nav-options",
  templateUrl: "./sub-nav-options.component.html",
  styleUrls: ["./sub-nav-options.component.less"],
})
export class SubNavOptionsComponent {
  @Input()
  public options: SubNavOption[];

  constructor(private stateService: StateService, private routerGlobals: UIRouterGlobals, private broadcastService: BroadcastService) {}

  public isActive(option: SubNavOption): boolean {
    if (option.isActive !== undefined) {
      return option.isActive;
    }
    const areCurrentAndOptionStatesEqual = this.routerGlobals.current.name === option.state;

    if (option.state === "gtmhub.insightboard") {
      const idParamValue = this.routerGlobals.params["dashboardId"];
      return areCurrentAndOptionStatesEqual && idParamValue === option.stateOptions.dashboardId;
    }

    if (option.state === "gtmhub.tasks") {
      const filterIdParamValue = this.routerGlobals.params["filterId"];
      return areCurrentAndOptionStatesEqual && filterIdParamValue === option.stateOptions.filterId;
    }

    return areCurrentAndOptionStatesEqual;
  }

  public view(option: SubNavOption): void {
    if (option.broadcastMessage !== undefined) {
      this.broadcastService.emit(option.broadcastMessage);
    }

    if (option.state) {
      window.setTimeoutOutsideAngular(() => {
        this.stateService.go(option.state, option.stateOptions);
      });
    }
  }
}
